var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackward = function SvgBackward(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.1668H3.34503L7.75586 1.75597L6.57753 0.577637L0.155029 7.00014L6.57753 13.4226L7.75586 12.2443L3.34503 7.83347H15.5V6.1668Z",
    fill: "#7E7E7E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackward);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNi4xNjY4SDMuMzQ1MDNMNy43NTU4NiAxLjc1NTk3TDYuNTc3NTMgMC41Nzc2MzdMMC4xNTUwMjkgNy4wMDAxNEw2LjU3NzUzIDEzLjQyMjZMNy43NTU4NiAxMi4yNDQzTDMuMzQ1MDMgNy44MzM0N0gxNS41VjYuMTY2OFoiIGZpbGw9IiM3RTdFN0UiLz4KPC9zdmc+Cg==";